var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { CustomElement, P, PCSS, Watch, PropertyConverters } from '@pacem/pacem-core';
import { PacemWidgetElement, buildWidgetMetadata } from '../types';
import { EXPRESSION_METADATA_TYPE } from '../../scaffolding/types';
//namespace Pacem.Components.Cms {
const DATA_METADATA = {
    display: { icon: 'storage', name: 'Data', description: 'Data object widget.' },
    props: [
        {
            prop: 'model', type: EXPRESSION_METADATA_TYPE, display: {
                name: 'Model'
            }, extra: {
                selector: '.' + PCSS + '-widget'
            }
        }
    ]
};
let PacemWidgetDataElement = class PacemWidgetDataElement extends PacemWidgetElement {
    constructor() {
        super(buildWidgetMetadata(DATA_METADATA));
    }
};
__decorate([
    Watch({ reflectBack: true, converter: PropertyConverters.Json })
], PacemWidgetDataElement.prototype, "model", void 0);
PacemWidgetDataElement = __decorate([
    CustomElement({
        tagName: P + '-widget-data'
    })
], PacemWidgetDataElement);
export { PacemWidgetDataElement };
